/**
 * 1.67 — whether the signed-in login is a waiter, derived from the store on every render (never stored: the cashier
 * rows can change under it, and a stored copy would drift). See `waiterAccessOf` in lib/roles.ts.
 */
import { useStore } from './store'
import { waiterAccessOf, type WaiterAccess } from './roles'

export function useWaiterAccess(): WaiterAccess {
  const userId = useStore((s) => s.cachedUserId)
  const role = useStore((s) => s.userRole)
  const cashiers = useStore((s) => s.cashiers)
  return waiterAccessOf(userId, role, cashiers)
}
